// extracted by css-extract-rspack-plugin
var _1 = "days-qkXxZ9";
var _2 = "times-hdOQpI";
export { _1 as "days", _2 as "times" }
